import { ref } from "vue";

const STORAGE_KEY = "serviceType";
const DEFAULT_SERVICE_TYPE = "2";

const ICON_BASE = "https://mini.hcdcdn.cn/static/service-logo/";

const themeConfig = {
  "2": {
    color: "#286bef",
    light: "#e9f0fd",
    bg: "#f5f8ff",
    pageBg: "",
    pageBgAlt: "",
    title: "团队角色测试",
    titleEn: 'TeamComple',
    icon: `${ICON_BASE}2.png`,
  },
  "21": {
    color: "#21CEB3",
    light: "#D3F5F0",
    bg: "#f0faf8",
    pageBg: "",
    pageBgAlt: "",
    title: "青少年团队角色测试",
    titleEn: 'TeamComple Youth',
    icon: `${ICON_BASE}21.png`,
  },
  "6": {
    color: "#323391",
    light: "#e7e6fe",
    bg: "#f7f7ff",
    pageBg: "linear-gradient(5deg, rgba(131,129,223,0) 0%, #8381df 35%, #8381df 100%)",
    pageBgAlt: "linear-gradient(360deg, #e7e6fe 0%, #eaf5ff 58%, #ffffff 100%)",
    title: "MBTI测试",
    titleEn: 'MBTI',
    icon: `${ICON_BASE}6.png`,
  },
  "61": {
    color: "#68CB75",
    light: "#e8f8ea",
    bg: "#f2faf3",
    pageBg: "url(https://mini.hcdcdn.cn/glp-mini/images/mbti_bg.png) repeat-y left top/cover",
    pageBgAlt: "url(https://mini.hcdcdn.cn/glp-mini/images/mbti_bg.png) repeat-y left top/cover",
    title: "青少年MBTI测试",
    titleEn: 'MBTI Youth',
    icon: `${ICON_BASE}61.png`,
  },
};

const serviceType = ref(localStorage.getItem(STORAGE_KEY) || DEFAULT_SERVICE_TYPE);

function getConfig() {
  return themeConfig[serviceType.value] || themeConfig[DEFAULT_SERVICE_TYPE];
}

export function getServiceType() {
  return serviceType.value;
}

export function setServiceType(val) {
  const value = String(val || DEFAULT_SERVICE_TYPE);
  serviceType.value = value;
  localStorage.setItem(STORAGE_KEY, value);
}

export function getThemeColor() {
  return getConfig().color;
}

export function getPageBg() {
  return getConfig().pageBg;
}

export function getPageBgAlt() {
  return getConfig().pageBgAlt;
}

export function getTitle() {
  const i18n = localStorage.getItem("i18n") || "zh";
  const cfg = getConfig();
  return i18n === "en" ? cfg.titleEn : cfg.title;
}

export function applyTheme() {
  const cfg = getConfig();
  const root = document.documentElement;
  root.style.setProperty("--theme-color", cfg.color);
  root.style.setProperty("--theme-color-light", cfg.light);
  root.style.setProperty("--theme-color-bg", cfg.bg);
  if (cfg.pageBg) {
    root.style.setProperty("--theme-page-bg", cfg.pageBg);
  }
  if (cfg.pageBgAlt) {
    root.style.setProperty("--theme-page-bg-alt", cfg.pageBgAlt);
  }
  root.style.setProperty("--van-primary-color", cfg.color);
  root.style.setProperty("--van-button-primary-background", cfg.color);
  root.style.setProperty("--van-button-primary-border-color", cfg.color);
  root.style.setProperty("--van-checkbox-checked-icon-color", cfg.color);
  root.style.setProperty("--van-dropdown-menu-title-active-text-color", cfg.color);

  const i18n = localStorage.getItem("i18n") || "zh";
  document.title = i18n === "en" ? cfg.titleEn : cfg.title;

  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = cfg.icon;
}

export function initThemeFromRoute(query) {
  if (query.serviceType) {
    setServiceType(query.serviceType);
  }
  applyTheme();
}

export { serviceType };
